var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    _vm._l(_vm.relationships, function (user) {
      return _c(
        "v-list-item",
        { key: user.id },
        [
          _c("SoliStudent", {
            attrs: { student: user, hasPaymentMethod: !!user.pm_last_four },
            on: {
              input: function ($event) {
                return _vm.$emit("input", user)
              },
            },
          }),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }